import React, { Fragment } from "react"
import styles from "./styles.css"

const DataTrafficSkeleton = () => {
  return (
    <Fragment>
      <div className={styles.mainSectionSkeleton}>
        <div className={styles.headSkeleton}>
          <div className={`${styles.skeletonTitle} ${styles.skeleton}`}></div>
          <div className={`${styles.selectSkeleton} ${styles.skeleton}`}></div>
        </div>
        <div className={styles.sectionSkeleton}>
          <div className={styles.blockSkeleton}>
            <div
              className={`${styles.skeletonSubtitle} ${styles.skeleton}`}
            ></div>
            <div className={styles.cardSectionSkeleton}>
              <div className={styles.cardSkeleton}>
                <div
                  className={`${styles.skeletonText} ${styles.skeleton}`}
                ></div>
                <div
                  className={`${styles.skeletonText} ${styles.skeleton}`}
                ></div>
                <div
                  className={`${styles.skeletonText} ${styles.skeleton}`}
                ></div>
              </div>
              <div className={styles.cardSkeleton}>
                <div
                  className={`${styles.skeletonText} ${styles.skeleton}`}
                ></div>
                <div
                  className={`${styles.skeletonText} ${styles.skeleton}`}
                ></div>
                <div
                  className={`${styles.skeletonText} ${styles.skeleton}`}
                ></div>
              </div>
            </div>
          </div>
          <div className={styles.blockSkeleton}>
            <div
              className={`${styles.skeletonSubtitle} ${styles.skeleton}`}
            ></div>
            <div>
              <div
                className={`${styles.skeletonButton} ${styles.skeleton}`}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default DataTrafficSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/DataTrafficSkeleton/index.js